(function() {
  'use strict';

  if (window.LTJCollectionFiltersLoaded) return;

  var filterPanel = document.querySelector('[data-ltj-shop-filters]');
  if (!filterPanel) return;

  window.LTJCollectionFiltersLoaded = true;

  var SHOP_PATH = filterPanel.getAttribute('data-ltj-shop-path') || '/collections/all';
  var sectionHost = filterPanel.closest('[data-section-id]');
  var SECTION_ID = sectionHost ? sectionHost.getAttribute('data-section-id') : '';
  var GROUPS = ['category', 'stone', 'type'];
  var activeRequest = null;
  var facetCache = {};

  // Category value -> storefront tag handle. Products carry cat:*, stone:* and type:* tags,
  // so every combination is a server-side tag filter: /collections/all/cat-jewelry+stone-ruby.
  var categoryTags = {};
  filterPanel.querySelectorAll('[data-ltj-filter-group="category"]').forEach(function(control) {
    categoryTags[control.getAttribute('data-ltj-filter-value')] = control.getAttribute('data-ltj-filter-tag');
  });

  // The options each group may offer, in display order. A category only shows the ones its
  // products actually have; products also carry other stone:/type: tags that are not offered here.
  var FACET_OPTIONS = {
    stone: [['jade', 'Jade'], ['ruby', 'Ruby'], ['sapphire', 'Sapphire'], ['emerald', 'Emerald'],
      ['coral', 'Coral'], ['pearl', 'Pearl'], ['amber', 'Amber']],
    type: [['necklace', 'Necklace'], ['bracelet', 'Bracelet'], ['earrings', 'Earrings'],
      ['ring', 'Rings'], ['pendant', 'Pendants']]
  };

  function facetLabel(group, value) {
    var option = FACET_OPTIONS[group].filter(function(entry) { return entry[0] === value; })[0];
    return option ? option[1] : value;
  }

  function offeredValues(group, available) {
    return FACET_OPTIONS[group].map(function(entry) { return entry[0]; }).filter(function(value) {
      return available.indexOf(value) !== -1;
    });
  }

  function currentParams() {
    return new URLSearchParams(window.location.search);
  }

  function selectedValue(params, group) {
    var value = params.get(group) || '';
    if (group === 'category') return categoryTags[value] ? value : '';
    // Stone/type are only meaningful inside a category.
    var offered = FACET_OPTIONS[group].some(function(entry) { return entry[0] === value; });
    return selectedValue(params, 'category') && offered ? value : '';
  }

  function tagPath(category, stone, type) {
    var tags = [categoryTags[category]];
    if (stone) tags.push('stone-' + stone);
    if (type) tags.push('type-' + type);
    return SHOP_PATH + '/' + tags.join('+');
  }

  function sourceUrl(params) {
    var category = selectedValue(params, 'category');
    var path = category ? tagPath(category, selectedValue(params, 'stone'), selectedValue(params, 'type')) : SHOP_PATH;
    var source = new URL(path, window.location.origin);
    params.forEach(function(value, key) {
      if (GROUPS.indexOf(key) === -1 && key !== 'section_id') {
        source.searchParams.append(key, value);
      }
    });
    return source;
  }

  function canonicalUrl(params) {
    var query = params.toString();
    return SHOP_PATH + (query ? '?' + query : '');
  }

  function filterLabel(group, value) {
    if (group !== 'category') return facetLabel(group, value);
    var control = filterPanel.querySelector('[data-ltj-filter-group="category"][data-ltj-filter-value="' + value + '"]');
    return control ? control.textContent.trim() : value;
  }

  function fetchFacetPage(path, page) {
    var url = new URL(path, window.location.origin);
    url.searchParams.set('view', 'ltj-facets');
    url.searchParams.set('page', page);
    return fetch(url.toString(), { credentials: 'same-origin' }).then(function(response) {
      if (!response.ok) throw new Error('Unable to load filters');
      return response.json();
    });
  }

  // Values a group can offer = values present in the results filtered by every OTHER group,
  // so stones narrow when a type is chosen and types narrow when a stone is chosen.
  // templates/collection.ltj-facets.liquid lists the tags of up to 250 products per page.
  function fetchFacets(category, stone, type) {
    var path = tagPath(category, stone, type);
    if (!facetCache[path]) {
      facetCache[path] = fetchFacetPage(path, 1)
        .then(function(first) {
          var rest = [];
          for (var page = 2; page <= first.pages; page++) rest.push(fetchFacetPage(path, page));
          return Promise.all(rest).then(function(pages) { return [first].concat(pages); });
        })
        .then(function(pages) {
          var facets = { stone: {}, type: {} };
          pages.forEach(function(data) {
            data.tags.forEach(function(tag) {
              var split = tag.indexOf(':');
              var group = tag.slice(0, split);
              if (facets[group]) facets[group][tag.slice(split + 1)] = true;
            });
          });
          return { stone: Object.keys(facets.stone), type: Object.keys(facets.type) };
        })
        .catch(function(error) {
          delete facetCache[path];
          throw error;
        });
    }
    return facetCache[path];
  }

  function renderFacetGroup(group, available, params) {
    var values = offeredValues(group, available);
    var wrap = filterPanel.querySelector('[data-ltj-facet-group="' + group + '"]');
    var list = filterPanel.querySelector('[data-ltj-facet-pills="' + group + '"]');
    if (!wrap || !list) return;
    list.innerHTML = '';
    var selected = selectedValue(params, group);

    values.forEach(function(value) {
      var next = new URLSearchParams(params.toString());
      next.set(group, value);
      next.delete('page');
      var option = document.createElement('a');
      option.className = 'ltj-sf-option';
      option.href = canonicalUrl(next);
      option.setAttribute('role', 'button');
      option.setAttribute('data-ltj-filter-group', group);
      option.setAttribute('data-ltj-filter-value', value);
      option.innerHTML = '<span class="ltj-sf-option__mark" aria-hidden="true"></span><span class="ltj-sf-option__label"></span>';
      option.lastChild.textContent = facetLabel(group, value);
      var active = value === selected;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-pressed', active ? 'true' : 'false');
      var item = document.createElement('li');
      item.appendChild(option);
      list.appendChild(item);
    });

    wrap.hidden = values.length === 0;
  }

  function updateFacets(params) {
    var category = selectedValue(params, 'category');
    if (!category) {
      renderFacetGroup('stone', [], params);
      renderFacetGroup('type', [], params);
      return Promise.resolve();
    }
    var stone = selectedValue(params, 'stone');
    var type = selectedValue(params, 'type');
    return Promise.all([fetchFacets(category, '', type), fetchFacets(category, stone, '')])
      .then(function(results) {
        // Ignore a response that arrives after the shopper has already moved on.
        if (currentParams().toString() !== params.toString()) return;
        // One filter after another: Category, then Stone (if the category has stones), then
        // Jewelry Type once a stone is picked, or straight after Category when there are no stones.
        var stonesOffered = offeredValues('stone', results[0].stone).length > 0;
        var showType = !stonesOffered || !!stone || !!type;
        renderFacetGroup('stone', results[0].stone, params);
        renderFacetGroup('type', showType ? results[1].type : [], params);
      })
      .catch(function() {});
  }

  function updateControls(params) {
    filterPanel.querySelectorAll('[data-ltj-filter-group]').forEach(function(control) {
      var group = control.getAttribute('data-ltj-filter-group');
      var active = control.getAttribute('data-ltj-filter-value') === selectedValue(params, group);
      control.classList.toggle('is-active', active);
      control.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var selectedWrap = filterPanel.querySelector('[data-ltj-selected-wrap]');
    var selectedContainer = filterPanel.querySelector('[data-ltj-selected-filters]');
    selectedContainer.innerHTML = '';
    var anySelected = false;

    GROUPS.forEach(function(group) {
      var value = selectedValue(params, group);
      if (!value) return;
      anySelected = true;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ltj-selected-filter';
      button.setAttribute('data-ltj-remove-filter', group);
      button.setAttribute('aria-label', 'Remove ' + filterLabel(group, value) + ' filter');
      button.textContent = filterLabel(group, value) + ' ×';
      selectedContainer.appendChild(button);
    });

    selectedWrap.hidden = !anySelected && !hasPriceFilter(params);

    var badge = document.querySelector('[data-ltj-filter-count]');
    if (badge) {
      badge.textContent = selectedContainer.children.length;
      badge.hidden = !selectedContainer.children.length;
    }
  }

  function hasPriceFilter(params) {
    var found = false;
    params.forEach(function(value, key) {
      if (key.indexOf('filter.v.price.') === 0) found = true;
    });
    return found;
  }

  function setStatus(message) {
    var status = filterPanel.querySelector('[data-ltj-filter-status]');
    if (status) status.textContent = message;
  }

  function resultCountText() {
    var count = document.querySelector('#Collection .ltj-collection-toolbar__count');
    return count ? count.textContent.trim() : 'Products updated';
  }

  function setLoading(loading) {
    var results = document.getElementById('Collection');
    if (!results) return;
    results.classList.toggle('ltj-collection-layout--loading', loading);
    if (loading) {
      results.setAttribute('aria-busy', 'true');
    } else {
      results.removeAttribute('aria-busy');
    }
  }

  function loadResults(params, options) {
    options = options || {};

    if (options.push) {
      window.history.pushState({}, '', canonicalUrl(params));
    }

    updateControls(params);
    updateFacets(params);

    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();
    setLoading(true);
    setStatus('Updating products…');

    var requestUrl = sourceUrl(params);
    if (SECTION_ID) requestUrl.searchParams.set('section_id', SECTION_ID);
    return fetch(requestUrl.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: activeRequest.signal
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to load products');
        return response.text();
      })
      .then(function(html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var nextResults = parsed.getElementById('Collection');
        var currentResults = document.getElementById('Collection');
        if (!currentResults || !nextResults) throw new Error('Product results were not found');

        currentResults.replaceWith(nextResults);
        nextResults.querySelectorAll('.editorial-reveal').forEach(function(el) {
          el.classList.add('is-visible');
        });
        setStatus(resultCountText() + ' shown');
        var resultCount = filterPanel.querySelector('[data-ltj-result-count]');
        if (resultCount) resultCount.textContent = resultCountText();
        // Bring the top of the new results into view if the shopper had scrolled past it.
        var top = nextResults.getBoundingClientRect().top;
        if (top < 0 && !filterPanel.classList.contains('is-open')) {
          window.scrollBy({ top: top - 24, behavior: 'smooth' });
        }
      })
      .catch(function(error) {
        if (error.name === 'AbortError') return;
        setLoading(false);
        setStatus('The products could not be updated. Please try again.');
      });
  }

  function selectFilter(group, value) {
    var params = currentParams();
    var currentValue = selectedValue(params, group);
    if (value && currentValue !== value) {
      params.set(group, value);
    } else {
      params.delete(group);
    }
    // A new category has its own stones and types; earlier picks may not exist in it.
    if (group === 'category') {
      params.delete('stone');
      params.delete('type');
    }
    params.delete('page');
    loadResults(params, { push: true });
  }

  function clearFilters() {
    var params = currentParams();
    var keysToDelete = [];
    params.forEach(function(value, key) {
      if (GROUPS.indexOf(key) !== -1 || key === 'page' || key.indexOf('filter.') === 0) {
        keysToDelete.push(key);
      }
    });
    keysToDelete.forEach(function(key) { params.delete(key); });
    loadResults(params, { push: true });
  }

  function updateFromResultLink(link) {
    var target = new URL(link.href, window.location.origin);
    var params = currentParams();
    var isPagination = !!link.closest('.pagination');

    if (isPagination) {
      if (target.searchParams.has('page')) {
        params.set('page', target.searchParams.get('page'));
      } else {
        params.delete('page');
      }
    } else {
      var priceKeys = [];
      params.forEach(function(value, key) {
        if (key.indexOf('filter.') === 0) priceKeys.push(key);
      });
      priceKeys.forEach(function(key) { params.delete(key); });
      target.searchParams.forEach(function(value, key) {
        if (key.indexOf('filter.') === 0) params.append(key, value);
        if (key === 'sort_by') params.set(key, value);
      });
      params.delete('page');
    }

    loadResults(params, { push: true });
  }

  // A tag URL opened directly (shared link, or a pill followed without JavaScript), e.g.
  // /collections/all/cat-jewelry+stone-ruby, becomes the matching ?category=&stone=&type= state.
  function paramsFromTagPath() {
    var params = currentParams();
    var prefix = SHOP_PATH + '/';
    if (window.location.pathname.indexOf(prefix) !== 0) return null;
    var tags = decodeURIComponent(window.location.pathname.slice(prefix.length)).split('+');
    var category = Object.keys(categoryTags).filter(function(value) {
      return tags.indexOf(categoryTags[value]) !== -1;
    })[0];
    if (!category) return null;
    params.set('category', category);
    tags.forEach(function(tag) {
      if (tag.indexOf('stone-') === 0) params.set('stone', tag.slice(6));
      if (tag.indexOf('type-') === 0) params.set('type', tag.slice(5));
    });
    return params;
  }

  // Below 990px the sidebar is a drawer. #PageContainer has a transform, which would pin a
  // position:fixed drawer to the page instead of the screen, so on small screens the drawer and
  // its backdrop live at the end of <body>, and move back beside the grid on large screens.
  var openButton = document.querySelector('[data-ltj-filter-open]');
  var backdrop = document.querySelector('.ltj-sf-backdrop');
  var drawerQuery = window.matchMedia('(max-width: 989px)');
  var sidebarHome = document.createComment('ltj-shop-sidebar');
  filterPanel.parentNode.insertBefore(sidebarHome, filterPanel);

  function placeSidebar() {
    if (drawerQuery.matches) {
      document.body.appendChild(filterPanel);
      if (backdrop) document.body.appendChild(backdrop);
    } else {
      setDrawer(false);
      sidebarHome.parentNode.insertBefore(filterPanel, sidebarHome.nextSibling);
      if (backdrop) filterPanel.parentNode.insertBefore(backdrop, filterPanel.nextSibling);
    }
  }

  function setDrawer(open) {
    filterPanel.classList.toggle('is-open', open);
    if (backdrop) backdrop.hidden = !open;
    document.documentElement.classList.toggle('ltj-sf-locked', open);
    if (openButton) openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var close = filterPanel.querySelector('.ltj-sf__close');
      if (close) close.focus();
    } else if (openButton && filterPanel.contains(document.activeElement)) {
      openButton.focus();
    }
  }

  // Keep the sticky sidebar just below the theme's sticky header, which shrinks once scrolled.
  var stickyHeader = document.querySelector('.ltj-sticky-wrap');
  var headerOffset = -1;
  var offsetFrame = 0;
  function updateHeaderOffset() {
    offsetFrame = 0;
    var height = Math.round(Math.max(0, stickyHeader.getBoundingClientRect().bottom));
    if (height === headerOffset) return;
    headerOffset = height;
    document.documentElement.style.setProperty('--ltj-sf-offset', height + 'px');
  }
  function queueHeaderOffset() {
    if (!offsetFrame) offsetFrame = window.requestAnimationFrame(updateHeaderOffset);
  }
  if (stickyHeader) {
    updateHeaderOffset();
    window.addEventListener('scroll', queueHeaderOffset, { passive: true });
    window.addEventListener('resize', queueHeaderOffset);
  }

  placeSidebar();
  if (drawerQuery.addEventListener) {
    drawerQuery.addEventListener('change', placeSidebar);
  } else if (drawerQuery.addListener) {
    drawerQuery.addListener(placeSidebar);
  }

  if (openButton) openButton.addEventListener('click', function() { setDrawer(true); });
  document.querySelectorAll('[data-ltj-filter-close]').forEach(function(control) {
    control.addEventListener('click', function() { setDrawer(false); });
  });
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && filterPanel.classList.contains('is-open')) setDrawer(false);
  });

  filterPanel.querySelectorAll('[data-ltj-group-toggle]').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) panel.hidden = !expanded;
    });
  });

  document.addEventListener('click', function(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var filterControl = event.target.closest('[data-ltj-filter-group]');
    if (filterControl && filterPanel.contains(filterControl)) {
      event.preventDefault();
      selectFilter(
        filterControl.getAttribute('data-ltj-filter-group'),
        filterControl.getAttribute('data-ltj-filter-value')
      );
      return;
    }

    var removeControl = event.target.closest('[data-ltj-remove-filter]');
    if (removeControl && filterPanel.contains(removeControl)) {
      event.preventDefault();
      var removeGroup = removeControl.getAttribute('data-ltj-remove-filter');
      selectFilter(removeGroup, '');
      return;
    }

    var clearControl = event.target.closest('[data-ltj-clear-filters]');
    if (clearControl && filterPanel.contains(clearControl)) {
      event.preventDefault();
      clearFilters();
      return;
    }

    var resultLink = event.target.closest('#Collection a[href]');
    if (resultLink && (resultLink.classList.contains('ltj-filter-opt') || resultLink.closest('.pagination'))) {
      event.preventDefault();
      updateFromResultLink(resultLink);
    }
  });

  document.addEventListener('change', function(event) {
    if (!event.target.matches('#Collection #SortBy')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var params = currentParams();
    params.set('sort_by', event.target.value);
    params.delete('page');
    loadResults(params, { push: true });
  }, true);

  window.addEventListener('popstate', function() {
    loadResults(currentParams(), { push: false });
  });

  var tagParams = paramsFromTagPath();
  if (tagParams) {
    // The server already rendered these results; only the URL and the controls need to catch up.
    window.history.replaceState({}, '', canonicalUrl(tagParams));
    updateControls(tagParams);
    updateFacets(tagParams);
  } else {
    var initialParams = currentParams();
    updateControls(initialParams);
    if (selectedValue(initialParams, 'category')) {
      loadResults(initialParams, { push: false });
    }
  }
})();
